import request from './request';
import { useSystemInfo } from '@/store';

export const getOpening = () => {
  const language = useSystemInfo().language
  return request({
    url: '/carbon-misc/public/web/config/site/startup/diagram',
    method: 'get',
    params: {
      language
    }
  });
}
